import getLocale from './utils/getLocale';
import isLocalStorageAvailable from '../src/utils/isLocalStorageAvailable';

const onClientEntry = (_, themeOptions) => {
  if (window.newrelic) {
    const mode = 'light';
    const locale = getLocale({ location: window.location }, themeOptions);

    window.newrelic.setCustomAttribute('mode', mode);
    window.newrelic.setCustomAttribute('locale', locale);
  }

  if (themeOptions.signup && themeOptions.tessen.segmentWriteKey) {
    window._nr_signup = {
      environment: `${themeOptions.signup.environment}`,
      reCaptchaToken: `${themeOptions.signup.reCaptchaToken}`,
      signupReceiverUrl: `${themeOptions.signup.signupUrl}`,
      segmentKey: `${themeOptions.tessen.segmentWriteKey}`,
    };
  }
  if (themeOptions.feedback && themeOptions.tessen.segmentWriteKey) {
    window._nr_feedback = {
      environment: `${themeOptions.feedback.environment}`,
      reCaptchaToken: `${themeOptions.feedback.reCaptchaToken}`,
      segmentKey: `${themeOptions.tessen.segmentWriteKey}`,
    };
  }

  if (themeOptions.newRelicRequestingServicesHeader) {
    window.newRelicRequestingServicesHeader =
      themeOptions.newRelicRequestingServicesHeader;
  }
};


export default onClientEntry;
